'use strict';

angular.module('ntmApp')
  .controller('listGridOpenDialogController', ['$scope', '$uibModalInstance', 'data', 'FlashService', 'Utils', 'EditForm',
      function ($scope, $uibModalInstance, data, FlashService, Utils, EditForm) {

          $scope.close = function () {
              $uibModalInstance.close();
          };

          $scope.dismiss = function () {
              $uibModalInstance.close();
          };

          $scope.callMethod = function (methodName) {
              $scope.editForm.SaveData(methodName).then(function (result) {
                  if (result.success) {
                      data.refreshGridData();
                      $uibModalInstance.close();
                  }
              });

          };
          
          $scope.$on('modal.closing', function (event, reason) {
              if (reason === 'backdrop click') {
                  $scope.close();
              }
          });

          function initData() {
              $scope.editForm = new EditForm(data);
          }

          initData();

      }]);